import { render, staticRenderFns } from "./AppInfo.vue?vue&type=template&id=269924ec&scoped=true&"
import script from "./AppInfo.vue?vue&type=script&lang=js&"
export * from "./AppInfo.vue?vue&type=script&lang=js&"
import style0 from "./AppInfo.vue?vue&type=style&index=0&id=269924ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269924ec",
  null
  
)

export default component.exports